import axios from 'axios'
import ETC from '../config/etc.config'
import APP from '../config/app.config'
import Plugins from '@/utils/plugins'

import QS from 'qs'

const biInstance = axios.create({
  baseURL: APP.BI_HTTP_URL,
  timeout: APP.HTTP_TIMEOUT,
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded'
  },
  transformRequest: [(data) => {
    data = QS.stringify(data)
    return data
  }]
})
// biInstance.headers.post['Content-Type'] = 'application/x-www-form-urlencoded'

// 平安好车主埋点
// const pahczInstance = axios.create({
//   baseURL: APP.HTTP_URL2,
//   timeout: APP.HTTP_TIMEOUT,
//   headers: {
//     'Content-Type': 'application/x-www-form-urlencoded'
//   },
//   transformRequest: [(data) => {
//     data = QS.stringify(data)
//     return data
//   }]
// })

function biLog({actionId, eventID, eventTypeId, pages, region, objName}) {
  // if (eventID) { // 新版埋点不需要eventID
  Plugins.systemDefer.promise.then(res => {
    biInstance.post('/bi-log', {
      // entry: localStorage.getItem(ETC.LOCAL_STORAGE_KEY.ENTRY),
      pl: ETC.APP_CHANNEL_PL[localStorage.getItem(ETC.LOCAL_STORAGE_KEY.APP_FROM_CHANNEL)] || '',
      entry_id: localStorage.getItem(ETC.LOCAL_STORAGE_KEY.ENTRY),
      pages: 'H5' + pages,
      action_id: actionId || '202', // 点击
      event_id: eventID,
      region: region || '',
      obj_name: objName || '',
      event_type_id: eventTypeId || '3', // 点击
      user_id: localStorage.getItem(ETC.LOCAL_STORAGE_KEY.ETC_UID),
      third_userid: localStorage.getItem(ETC.LOCAL_STORAGE_KEY.UUID),
      channel: ETC.APP_LOGIN_TYPES[localStorage.getItem(ETC.LOCAL_STORAGE_KEY.APP_FROM_CHANNEL)],
      user_tokens: localStorage.getItem(ETC.LOCAL_STORAGE_KEY.TOKEN),
      network_type: (navigator.connection || {}).effectiveType,
      brand: res.phone,
      phone_model: res.model,
      pages_timestamp: new Date().getTime()
    }, {'Content-Type': 'application/x-www-form-urlencoded'}).catch(e => {
      console.log('bilog err', e)
    })
  })
  // }
}

// function pahczBILog({pageId, pageName, url}) {
//   if (pageId) {
//     Plugins.systemDefer.promise.then(res => {
//       if (localStorage.getItem(ETC.LOCAL_STORAGE_KEY.APP_FROM_CHANNEL) === 'pahcz') {
//         pahczInstance.post('/data-upload/pingan-good-car-owner-svr', {
//           hopenId: localStorage.getItem(ETC.LOCAL_STORAGE_KEY.PAHCZ_OPENID),
//           pageId,
//           pageName,
//           url
//         }, {'Content-Type': 'application/x-www-form-urlencoded'}).catch(e => {
//           console.log('bilog err', e)
//         })
//       }
//     })
//   }
// }

export {biLog}
